var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Plier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 33.34V37h-5.3a4 4 0 00-7.41 0H45v-9h14l13 5.34zm-9 9.16a4 4 0 01-3.7-2.5H45v9h14l13-5.34V40h-5.3a4 4 0 01-3.7 2.5zM35 30.36l-27.91-4a3 3 0 10-.84 5.94L35 36.42v3.7L6.24 44.2a3 3 0 10.84 5.94l27.91-4V51h6V27H35v3.36z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Plier.156017e6.svg";
export { SvgA4Plier as ReactComponent };